import { render, staticRenderFns } from "./AdminTemplates.vue?vue&type=template&id=22a3f23f&scoped=true&"
import script from "./AdminTemplates.vue?vue&type=script&lang=js&"
export * from "./AdminTemplates.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AdminTemplates.vue?vue&type=style&index=1&id=22a3f23f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3f23f",
  null
  
)

export default component.exports